//
//
//
//

import {
  centerBingMapUsingBounds,
  geocodeByCountryCode,
  initializeBingMaps,
} from '@/scripts/libs/bing-maps'
import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

export default {
  name: 'rb-bing-maps',
  data() {
    return {
      containerId: 'rb-bing-maps',
      map: undefined,
    }
  },
  mounted() {
    this.initializeMap()
  },
  methods: {
    initializeMap() {
      const { locale } = wcs.getStoreConfig()

      const countryCode = WcsLocales.mapCountryCode(locale)

      this.map = initializeBingMaps(`#${this.containerId}`)
      geocodeByCountryCode(this.map, countryCode, (answer) => {
        centerBingMapUsingBounds(this.map, answer.results[0].bestView)
      })
      this.$emit('bingMapLoaded', this.map)
    },
  },
}
